import React, { useState, FormEvent } from 'react';
import shufflrLogo from '../assets/logo.svg';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import {
  authPageStyle, authCardStyle, authLogoStyle, authTaglineStyle,
  authHeadingStyle, authFormStyle, authLabelStyle, authInputStyle,
  authSubmitStyle, authSwitchStyle, authLinkStyle, authErrorStyle,
} from '../App.styles';

interface LoginPageProps {
  onSwitchToRegister: () => void;
}

export function LoginPage({ onSwitchToRegister }: LoginPageProps): React.JSX.Element {
  const { login } = useAuth();
  const { slug } = useTenant();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!slug) { setError('No organisation found — check your URL.'); return; }
    setError(null);
    setLoading(true);
    try {
      await login(email, password, slug);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={authPageStyle}>
      <div style={authCardStyle}>
        <img src={shufflrLogo} alt="Shufflr" style={{ ...authLogoStyle, filter: 'none' }} />
        <p style={authTaglineStyle}>Good Games · Great Vibes</p>
        <h1 style={authHeadingStyle}>Welcome back</h1>

        {error && <div style={authErrorStyle}>{error}</div>}

        <form style={authFormStyle} onSubmit={handleSubmit} noValidate>
          <label style={authLabelStyle}>
            Email
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
              style={authInputStyle}
            />
          </label>

          <label style={authLabelStyle}>
            Password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              style={authInputStyle}
            />
          </label>

          <button type="submit" disabled={loading} style={authSubmitStyle}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p style={authSwitchStyle}>
          Don't have an account?{' '}
          <button style={authLinkStyle} onClick={onSwitchToRegister} type="button">
            Create one
          </button>
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
